<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} EXPENSE CATEGORY</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <span class="px-2" style="font-size:12px">Active?</span> 
        <vs-switch color="primary" color-off="danger" v-model="dataIsActive">
        <span slot="on">On</span>
        <span slot="off">Off</span>
        </vs-switch>
        <!-- NAME EN -->
        <vs-input label="Name EN *" v-model="dataNameEN" class="mt-5 w-full" name="name_en"  v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('name_en')">{{ errors.first('name_en') }}</span>
        <!-- NAME FR -->
        <vs-input label="Name FR" v-model="dataNameFR" class="mt-5 w-full" name="name_fr"/>
        <span class="text-danger text-sm" v-show="errors.has('name_fr')">{{ errors.first('name_fr') }}</span>
        <!-- NAME RO -->
        <vs-input label="Name RO" v-model="dataNameRO" class="mt-5 w-full" name="name_ro"/>
        <span class="text-danger text-sm" v-show="errors.has('name_ro')">{{ errors.first('name_ro') }}</span>
        <!-- REF PRICE -->
        <vs-input label="Accounting Code" v-model="dataAccounting" class="mt-5 w-full" name="accountingcode"/>
        
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>
 
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from '@/axios.js'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () { 
    return {  
      dataId: null,
      dataNameFR: '',
      dataNameRO: '',
      dataNameEN: '',
      dataAccounting: '',
      dataIsActive:true,     
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) { 
        this.initValues()
        this.$validator.reset()
        this.dataId = null
      } else {
        const { id, name_en, name_fr, name_ro, isactive, accounting_code } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id,
        this.dataNameEN = name_en,
        this.dataNameFR = name_fr,
        this.dataNameRO = name_ro,
        this.dataIsActive = isactive,
        this.dataAccounting = accounting_code,
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataNameEN 
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
  },
  methods: {
    initValues () {
      if (this.data.id) return
        this.dataId = '',
        this.dataNameEN = '',
        this.dataNameFR = '',
        this.dataNameRO = '',
        this.dataAccounting = '',
        this.dataIsActive = true
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name_en: this.dataNameEN,
            name_fr: this.dataNameFR,
            name_ro: this.dataNameRO,
            accounting_code: this.dataAccounting,
            isactive: this.dataIsActive
          }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('dataListOutlayCategory/updateItem', obj).catch(err => { console.error(err) })
            this.$vs.notify({
              color: 'success',
              title: 'Outlay Category Updated!',
              text: 'The category was successfully edited'
            })
          }
          else {
            delete obj.id
            this.$store.dispatch('dataListOutlayCategory/createItem', obj).catch(err => { console.error(err) })
            this.$vs.notify({
              color: 'success',
              title: 'Outlay Category Created!',
              text: 'The category was successfully added'
            })
          }
          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
